var _circle, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonIba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "#1C74D0",
    fillOpacity: 0.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_829_2545)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 20.0001,
    r: 15.381,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0628 18.8826C23.1505 18.0893 23.8589 16.8054 23.8589 15.359C23.8589 12.9554 21.9035 11 19.4999 11C17.0964 11 15.1409 12.9554 15.1409 15.359C15.1409 16.8054 15.8493 18.0893 16.9371 18.8826C14.233 19.9174 12.3076 22.5391 12.3076 25.6026C12.3076 26.9245 13.3831 28 14.705 28H24.2948C25.6167 28 26.6922 26.9245 26.6922 25.6026C26.6922 22.5391 24.7668 19.9174 22.0628 18.8826ZM16.4486 15.359C16.4486 13.6765 17.8174 12.3077 19.4999 12.3077C21.1824 12.3077 22.5512 13.6765 22.5512 15.359C22.5512 17.0414 21.1824 18.4103 19.4999 18.4103C17.8174 18.4103 16.4486 17.0414 16.4486 15.359ZM24.2948 26.6923H14.705C14.1042 26.6923 13.6153 26.2034 13.6153 25.6025C13.6153 22.3577 16.2551 19.7179 19.4999 19.7179C22.7448 19.7179 25.3846 22.3577 25.3846 25.6025C25.3845 26.2034 24.8957 26.6923 24.2948 26.6923Z",
    fill: "#1C74D0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_829_2545",
    x: 0.618896,
    y: 0.619141,
    width: 38.762,
    height: 38.7617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.454902 0 0 0 0 0.815686 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_829_2545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_829_2545",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIba);
export default __webpack_public_path__ + "static/media/personIba.3de424c655e7c7db43a9300bccadd21b.svg";
export { ForwardRef as ReactComponent };